import { render } from "./trend.vue?vue&type=template&id=09d207f6&scoped=true&ts=true"
import script from "./trend.vue?vue&type=script&lang=ts"
export * from "./trend.vue?vue&type=script&lang=ts"

import "./trend.vue?vue&type=style&index=0&id=09d207f6&lang=less"
import "./trend.vue?vue&type=style&index=1&id=09d207f6&scoped=true&lang=less"

import exportComponent from "E:\\operationmanualNew\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-09d207f6"]])

export default __exports__